export default {
  vabI18n: {},
}
